import { CombinedError } from 'urql';

import { appStore } from './appStore';

class RequestError {
  id: string;
  err: Error;
  retry: () => void;
  constructor(err: CombinedError, retry: () => void) {
    this.id = self.crypto.randomUUID();
    this.err = err;
    this.retry = () => {
      removeRequestErrorById(this.id);
      retry();
    };
    return this;
  }
}

function reportRequestError(err: CombinedError, retry: () => void): string {
  const requestError = new RequestError(err, retry);
  appStore.requestErrors.push(requestError);
  return requestError.id;
}

function getRequestErrorById(id: string | null): RequestError | null {
  return appStore.requestErrors.find((err) => err.id === id) || null;
}

function removeRequestErrorById(id: string) {
  const index = appStore.requestErrors.findIndex((err) => err.id === id);
  if (index >= 0) {
    appStore.requestErrors.splice(index, 1);
  }
}

function retryAfterRequestError(errorId: string | null) {
  const requestError = getRequestErrorById(errorId);
  if (requestError) {
    requestError.retry();
  }
}

function retryAllAfterRequestErrors() {
  while (appStore.requestErrors.length > 0) {
    const error = appStore.requestErrors.pop();
    error?.retry();
  }
}

export {
  RequestError,
  reportRequestError,
  getRequestErrorById,
  removeRequestErrorById,
  retryAfterRequestError,
  retryAllAfterRequestErrors,
};
